import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import './styles.scss'
import Busket from './busket'

import moreInfo from './assets/more_info.svg'

const modalRoot = document.getElementById('basket') as HTMLElement;


class BusketRigth extends Component<any, any> {


    public render() {
        return (
            ReactDOM.createPortal(
                <Busket/>,
                modalRoot
            )
        )

    }
}



export default BusketRigth